import { onViewLoad } from "~/jose_modern/on_view_load";
import { initializeInventoryAdjustPage } from "./shared/inventory_adjustments";
import { setupUnitChangeModal } from "./shared/inventory_adjustments/editing";

const FINISHED_GOODS_CONFIG = {
  resource: "finished_goods",
  resourceSingle: "finished_good",

  userFacingText: {
    singular: "finished goods",
    singularPossessive: "finished good's",
    pluralPossessive: "finished goods'",
    inventoryTypeLabel: "FG",
  },

  onInit: () => {
    setupUnitChangeModal();
  },
};

onViewLoad("users#edit_finished_goods", () => {
  initializeInventoryAdjustPage(FINISHED_GOODS_CONFIG);
});
